import React, { useState } from "react";
import { Route, Redirect } from "react-router-dom";
import SignIn from "../views/SignIn";
import { isEmpty } from "lodash";
import Drawer from "../views/Drawer";

export function PrivateRoute({ children, ...rest }) {
  const [islogin, setislogin] = useState(false);

  setInterval(() => {
    const account = localStorage.getItem("Account");
    if (!isEmpty(account)) {
      setislogin(true);
    } else {
      setislogin(false);
    }
  }, 1000);

  return <Route {...rest} render={() => (islogin ? <Drawer /> : <SignIn />)} />;
}
